( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'soldier-card', COMPONENT );
} )( app );
